export default {
  initialLevel: 'Nivel Inicial',
  finalLevel: 'Nivel Final',
  initialLevelError: 'Nivel inicial no debe ser superior al nivel final',
  finalLevelError: 'Nivel final no debe ser menor al nivel inicial',
  pedagogicalHoursTotal: 'Horas pedagógicas totales',
  totalHours: 'Total de Horas',
  automatic: 'Automático',
  planned: 'Planificado',
  credit: 'Crédito',
  greaterThanOrEqualToZeroError: 'Este campo debe ser mayor o igual a cero.',
  elective: 'electivas',
  noElectiveMatters: 'No cuenta con {entity} electivas.',
}
